export function getParentOrigin(): string | undefined {
  if (window.parent === window) {
    return undefined;
  }
  return new URL(document.referrer).origin;
}
